<div fxLayout="row" fxLayoutAlign="start">

  <div class="card">

    <div fxLayout="column" fxLayoutAlign="space-evenly stretch" style="margin:5px">
      Template Store
      <div>
        <kendo-dropdownlist
          [data]="templateStoreList"
          textField="display"
          valueField="storeID"
          [(ngModel)]="selectedTemplateStore"
          (valueChange)="templateStoreValueChange($event)"
          name="selectedChain"
          style="width:300px; height: 30px ">
        </kendo-dropdownlist>
      </div>
      <p></p>
      GL Segment for (Selected Template Store)
      <div fxLayout="row" fxLayoutAlign="start">
        <div *ngFor="let segment of this.templateSegments">
          <input style="width: 30px; margin-right: 10px;" [disabled]="false" [(ngModel)]="segment.length" name="segment" kendoTextBox/>
        </div>
      </div>

      <p></p>
      <div>AP GL Codes</div>
      <div fxLayout="row" fxLayoutAlign="start">
          <div *ngFor="let code of this.templateGlCodes; let in = index;">
            <kendo-textbox style="width: 100px; margin-right: 10px;"
                           id="templateSegement{{in}}"
                           [style.marginBottom.px]="10"
                           [showSuccessIcon]="false"
                           [(ngModel)]="this.templateGlCodes[in]"
                           (valueChange)="onChangeTemplateSegment($event, code, in)">
            </kendo-textbox>
            <!-- <kendo-textbox [(ngModel)]="code"></kendo-textbox> -->
          </div>
      </div>
    </div>

  </div>

  <div class="card">
    <div fxLayout="column" fxLayoutAlign="space-evenly stretch" style="margin:5px; text-wrap: nowrap;">

      Target Store
      <div>
        <kendo-dropdownlist
          [data]="targetStoreList"
          textField="display"
          valueField="storeID"
          [(ngModel)]="selectedTargetStore"
          (valueChange)="targetStoreValueChange($event)"
          name="selectedDivision"
          style="width:300px; height: 30px ">
        </kendo-dropdownlist>
      </div>
      <p></p>
      GL Segment for {{this.selectedTargetStore.storeID}}
      <div fxLayout="row" fxLayoutAlign="start">
        <div fxLayout="row" fxLayoutAlign="start">
          <div *ngFor="let segment of this.targetSegments">
            <input style="width: 30px;" [disabled]="false" [(ngModel)]="segment.length" name="segment" kendoTextBox/>
          </div>
        </div>
      </div>


      <p></p>
      <div>Segments (Check segment if it is fixed)</div>

      <div fxLayout="row" fxLayoutAlign="start">
        <form *ngIf="this.templateGlCodes.length>0" [formGroup]="formGroup">
          <div fxLayout="column" fxLayoutAlign="start">
            <div formArrayName="segments" *ngFor="let segment of formSegments.controls; let in = index; ">
              <div [formGroupName]="in">
                <input kendoCheckBox  formControlName="checkBox" id="{{'checkBox' + in}}" type="checkbox"
                       (click)="segmentCheckboxClicked(in, segment)" style="margin-right: 10px;">
                <kendo-textbox  formControlName="textBox" id="{{'textBox' + in}}"
                               (valueChange)="onChangeTargetSegment($event, segment.value, in)" style="margin-top: 10px;">
                </kendo-textbox>
              </div>
            </div>
          </div>
          <p></p>
          <div fxLayout="row" fxLayoutAlign="end center">
            <button kendoButton (click)="preview()"
                    [disabled]="this.previewDisabled || formGroup.invalid || formGroup.pristine"
                    [primary]="true">Preview
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>

</div>
<div kendoDialogContainer></div>
